export default __webpack_public_path__ + "static/media/greenctg.c0b141bb.jpg";